module.exports = "<p ng-repeat=\"news in $ctrl.data\">\r\n    <a style=\"float:right; margin-left: 8px\" ng-href=\"/news/{{news._id}}\" class=\"btn btn-sm btn-more\"><i class=\"fa fa-arrow-circle-right\"></i> more</a>\r\n    <b>{{news.title}}</b><br/><em ng-bind-html=\"$ctrl.getPreviewText(news.body)\"></em>\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/news-widget/news-widget.component.html
// module id = 605
// module chunks = 0